module.exports = __webpack_public_path__ + "img/zoom_room.ff418275.svg";